export class BaseNodeTreeStrategy {
    createNodeTree(context) {
        return this.createNodeTreeChild('node');
    }

    createNodeTreeChild(name) {
        return { name: name, children: [] };
    }

    addPathToNodeTree(tree, path) {
        let child = tree.children.find(child => child.name === path[0]);
        if (!child) {
            child = this.createNodeTreeChild(path[0]);
            tree.children.push(child);
        }
        if (path.length > 1) {
            this.addPathToNodeTree(child, path.slice(1));
        }
    }

    buildNodeTree(intoQueryBuilder, fromContext) {
        const nodeTree = this.createNodeTree(fromContext)

        // Obtengo las caracteristicas de los campos/columnas, mapeos y filtros
        fromContext.fieldDescriptions.forEach(desc => {
            // Agregar campos de retorno basándose en el mapper
            if (desc.tableMapper && desc.tableMapper.mapperPaths) {
                desc.tableMapper.mapperPaths.forEach(path => {
                    this.addPathToNodeTree(nodeTree, path);
                });
            }
        });

        intoQueryBuilder.setNodeTree(nodeTree);
    }


}
